// extracted by mini-css-extract-plugin
module.exports = {"day":"_34ho_jX4BnAL _1SymvMubafZq","dayOfWeekName":"_2R3M0gBP9jrT","dayOfWeekName_withPrices":"_34Aw-OzMmbOU"};